import { useEffect, useState } from "react";
import {
  distanceInMeters,
  getLocationPermission,
} from "../../utils/geolocation";

const WATCH_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 15000,
  maximumAge: 30000,
};

// Live "you are ~X m from your branch". Only watches the position when the
// browser already allows location, so it never triggers a permission prompt
// by itself. Informational only: the server decides on check-in.
//   report(location): feed a position taken elsewhere (e.g. at check-in)
export const useBranchDistance = (branch) => {
  const [position, setPosition] = useState(null);
  const hasBranchPoint = !!branch?.hasLocation;

  useEffect(() => {
    if (!hasBranchPoint) return undefined;
    let watchId = null;
    let active = true;

    getLocationPermission().then((state) => {
      if (!active || state !== "granted") return;
      watchId = navigator.geolocation.watchPosition(
        ({ coords }) =>
          setPosition({
            latitude: coords.latitude,
            longitude: coords.longitude,
            accuracy: coords.accuracy,
          }),
        () => {},
        WATCH_OPTIONS,
      );
    });

    return () => {
      active = false;
      if (watchId != null) navigator.geolocation.clearWatch(watchId);
    };
  }, [hasBranchPoint]);

  const distance =
    hasBranchPoint && position
      ? distanceInMeters(position, {
          latitude: Number(branch.latitude),
          longitude: Number(branch.longitude),
        })
      : null;

  return {
    distance,
    accuracy: position?.accuracy ?? null,
    report: setPosition,
  };
};
